// extracted by mini-css-extract-plugin
module.exports = {"header":"_7a3fb80146--header--KXX2K","container":"_7a3fb80146--container--Ab5SA","slider":"_7a3fb80146--slider--NWRH8"};